// Function to insert spaces before each capital letter
export const addSpacesToTitleCase = (key: string) => {
    return key.replace(/([A-Z])/g, " $1").trim();
};

